import { render } from "./ReadView.vue?vue&type=template&id=7bac37ec&scoped=true"
import script from "./ReadView.vue?vue&type=script&lang=js"
export * from "./ReadView.vue?vue&type=script&lang=js"

import "./ReadView.vue?vue&type=style&index=0&id=7bac37ec&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bac37ec"]])

export default __exports__